import LFCDialogTitle from '_components/feedback/LFCDialogTitle';
import LFCButton from '_components/inputs/LFCButton';
import ProgressBar from '_components/ProgressBar';
import {setLFCDataProc} from '_logics/LFCUtil';
import axios, {CancelTokenSource} from 'axios';
import {useSnackbar} from 'notistack';
import {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';

import {Dialog, DialogActions, DialogContent, TextField} from '@mui/material';

interface Props {
  open: boolean;
  onClose: (isRefresh: boolean) => void;
  floorId: number;
  floorName: string;
}

const FloorRenameDialog = (props: Props) => {
  const {t} = useTranslation();
  const {enqueueSnackbar} = useSnackbar();
  const [startProcess, setStartProcess] = useState(false);
  const [floorName, setFloorName] = useState('');
  const cancelSource = useRef<CancelTokenSource | null>(null);

  useEffect(() => {
    if (props.open) {
      setFloorName(props.floorName);
    }
  }, [props.open, props.floorName]);

  useEffect(() => {
    return () => {
      if (cancelSource.current) cancelSource.current.cancel('req cancel');
    };
  }, []);

  const onSave = () => {
    if (floorName.trim() === '') {
      enqueueSnackbar(t('フロア名を入力してください'), {variant: 'error'});
      return;
    }

    setStartProcess(true);
    cancelSource.current = axios.CancelToken.source();
    Promise.allSettled([
      setLFCDataProc({
        snack: enqueueSnackbar,
        name: '名称変更',
        invoke_name: 'UpdateFloorName',
        parameters: {
          floorId: props.floorId,
          floorName: floorName.trim()
        },
        cancelToken: cancelSource.current.token,
        t
      })
        .then(() => props.onClose(true))
        .catch(err => {
          console.error(err);
          enqueueSnackbar(t('名称変更に失敗しました'), {variant: 'error'});
        })
    ]).finally(() => setStartProcess(false));
  };

  return (
    <Dialog open={props.open} onClose={() => props.onClose(false)} maxWidth="xs" fullWidth>
      <ProgressBar startProcess={startProcess} screenLock />
      <LFCDialogTitle onClose={() => props.onClose(false)}>{t('フロア名変更')}</LFCDialogTitle>
      <DialogContent dividers>
        <TextField
          label={t('新しいフロア名')}
          size="small"
          fullWidth
          required
          value={floorName}
          onChange={e => setFloorName(e.target.value)}
          onKeyDown={e => {
            if (e.key === 'Enter') onSave();
          }}
        />
      </DialogContent>
      <DialogActions>
        <LFCButton onClick={() => props.onClose(false)}>{t('キャンセル')}</LFCButton>
        <LFCButton color="primary" onClick={onSave}>
          {t('保存')}
        </LFCButton>
      </DialogActions>
    </Dialog>
  );
};

export default FloorRenameDialog;
